import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export interface TaxClosingPeriodItem {
  id: number;
  month: number;
  year: number;
  status: "BLOCKED" | "RELEASED" | "CLOSED";
  releasedBy: string | null;
  releasedByName: string | null;
  releasedAt: string | null;
  observation: string | null;
  created_at: string;
  updated_at: string;
}

export interface TaxClosingPeriodRequest {
  month: number;
  year: number;
  observation?: string;
}

export const taxClosingPeriodApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMonthControls: builder.query<TaxClosingPeriodItem[], void>({
      query: () => "/tax/closing-periods",
      providesTags: [Tags.TAX_CLOSING_PERIOD],
    }),

    releaseMonth: builder.mutation<TaxClosingPeriodItem, TaxClosingPeriodRequest>({
      query: (body) => ({
        url: "/tax/closing-periods/release",
        method: "POST",
        body,
      }),
      invalidatesTags: [Tags.TAX_CLOSING_PERIOD],
    }),

    blockMonth: builder.mutation<TaxClosingPeriodItem, TaxClosingPeriodRequest>({
      query: (body) => ({
        url: "/tax/closing-periods/block",
        method: "POST",
        body,
      }),
      invalidatesTags: [Tags.TAX_CLOSING_PERIOD],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetMonthControlsQuery,
  useReleaseMonthMutation,
  useBlockMonthMutation,
} = taxClosingPeriodApi;
